const buildRequestData = (datosFormulario, ruta) => {
    return {
      coordenadas: datosFormulario.coordenadas,
      radio: datosFormulario.radio,
      valorBoton: Number(datosFormulario.valorBoton ?? 0),
      tiempoAudioVelocidad: Number(datosFormulario.tiempoAudioVelocidad ?? 0),
      tiempoAudioGeocerca: Number(datosFormulario.tiempoAudioGeocerca ?? 0),
      sonidosVelocidadModel: {
        id: datosFormulario.velocidad,
      },
      sonidosGeocercaModel: {
        id: datosFormulario.geocerca,
      },
      rutasModel: {
        id: ruta,
      },
    };
  };
  
  export default buildRequestData;
